<template>
  <div class="row justify-content-between dashboard-filter">
    <div class="col-xl-7">
      <b-tabs class="tabs-list" fill>
        <b-tab v-for="(tab, index) in tabs" :key="index">
          <template #title>
            <img
              :src="require(`@/assets/images/icons/dashboard/${tab.icon}`)"
            />
            <span>{{ tab.text }}</span>
          </template>
        </b-tab>
      </b-tabs>
    </div>

    <div class="col-xl-4 dashboard-filter__row">
      <button class="btn btn--outlined-gray">
        <img src="@/assets/images/icons/dashboard/chart.svg" />
      </button>
      <button class="btn btn--gradient-purple">EXL</button>
      <button class="btn btn--gradient-purple">PDF</button>
      <div class="dashboard-filter__select">
        <b-form-select :value="null" :options="options" />
      </div>
    </div>
    <div class="col-12">
      <div class="dashboard-filter__actions">
        <a href="#" class="d-inline-flex">
          <img
            class="m-auto"
            :src="require(`@/assets/images/icons/dashboard/grid.svg`)"
          />
        </a>
        <a href="#" class="d-inline-flex mr-lg-auto">
          <img
            class="m-auto"
            :src="require(`@/assets/images/icons/dashboard/grid-2.svg`)"
        /></a>
        <button
          v-for="(item, index) in actions"
          :key="index"
          class="btn btn--outlined-gray"
          @click="handleSelectedAction(item)"
        >
          <img
            :src="require(`@/assets/images/icons/dashboard/${item.icon}.svg`)"
          />
        </button>
      </div>
    </div>
    <ProductsListSideBarFilter ref="sidebar-filter" />
  </div>
</template>

<script>
import { BTabs, BTab, BFormSelect } from "bootstrap-vue";
import ProductsListSideBarFilter from "@/components/dashboard/ProductsListSideBarFilter.vue";
export default {
  name: "ProductsListFilter",
  components: {
    BTabs,
    BTab,
    BFormSelect,
    ProductsListSideBarFilter,
  },
  data() {
    return {
      tabs: [
        {
          text: "كل المنتجات",
          icon: "product.svg",
        },
        {
          text: "الجاهزة",
          icon: "product.svg",
        },
        {
          text: "حسب الطلب",
          icon: "product.svg",
        },
        {
          text: "اشتراكات",
          icon: "product.svg",
        },
        {
          text: "حجز وتأجير",
          icon: "product.svg",
        },
      ],
      options: [
        { value: null, text: "اختر النوع", disabled: true },
        { value: "a", text: "option 1" },
        { value: "b", text: "option 2" },
      ],
      actions: [
        { icon: "plus-2" },
        { icon: "chart" },
        { icon: "link" },
        { icon: "box" },
        { icon: "delete" },
        { icon: "filter", action: this.showSideBarFilter },
        { icon: "plus", action: this.openProductFormModal },
        { icon: "edit" },
        { icon: "view" },
        { icon: "save" },
      ],
    };
  },
  methods: {
    showSideBarFilter() {
      this.$refs["sidebar-filter"].showSideBar = true;
    },
    handleSelectedAction(item) {
      item.action && item.action();
    },
    openProductFormModal() {
      this.$bvModal.show("product-form-modal");
    },
  },
};
</script>
